import { Component, inject, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
    selector: 'kbm-loading',
    standalone: true,
    imports: [
        MatIconModule
    ],
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {

  loadingService =  inject(LoadingService);

  loading = this.loadingService.loading;
}
